import gql from 'graphql-tag';

export default gql`
  query orderContent(
    $OrderType: String
    $OrderDate: String
    $removedItem: String
  ) {
    orderContent(
      OrderType: $OrderType
      OrderDate: $OrderDate
      removedItem: $removedItem
    ) {
      OrderNo
      Note
      OrderDate
      OrderType
      shouldHaveDatePicker
      Account {
        AcctNo
        Days
      }
      ShipTo
      Det {
        Price {
          value
          rawValue
          pricingTiers {
            tier
            price
          }
          product {
            Uom
            Code
            Brand
            Desc
            Vintage
          }
          mixedSizeItems {
            Code
            Brand
            Desc
            Vintage
          }
        }
        Uom
        Cases
        Bottles
        Code
        Description
        Mobo
        MoboQty {
          OrderNo
          OrderNoMobo
          Qty
        }
        maxItemQty {
          ActionPerOrderType
          byOrderType {
            id
            Qty
            Cases
            Bottles
          }
          PreviousAdd {
            Qty
            Cases
            Bottles
          }
        }
        Qty
        QtyA
      }
    }
  }
`;
